module.exports = __webpack_public_path__ + "static/media/addr_label_icon.5045beec.svg";